module.exports = __webpack_public_path__ + "img/Logo-qingmang.83779a69.png";